/**
 * Message Templates role actions.
 *
 * ⚠️ NAVIGATION ONLY — not a security boundary. api.core's `MessageTemplate` controller requires no
 * action key: any authenticated user may call it, and a template belongs to the USER who made it.
 *
 * ⚠️ The key does not exist in the backend catalogue yet. Until it is added to `ActionKeys.cs`,
 * synced, granted and users re-log, the sidebar entry borrows `VOTER_INTERACTION` with the real
 * intent recorded in `intendedRoleActions` — the same arrangement as `actions.contacts.ts`.
 */
export const ACTIONS_MESSAGE_TEMPLATES = {
	MESSAGE_TEMPLATES: 'message_templates',
} as const;
